export default __webpack_public_path__ + "static/media/CarExteriorDetailing.40d150b4.jpg";